/**
 * @desc 出库计划单历史数据锁定库存
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/test/opHistoryLockInventory/`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
